export enum eAccessLevel {
  none = "No access",
  viewer = "Viewer",
  editor = "Editor",
  lead = "Lead",
  admin = "Admin",
  remove = "Remove rights",
}

export enum eAccessRights {
  CreateHierarchy = "CreateHierarchy",
  DeleteHierarchy = "DeleteHierarchy",
  DeleteReport = "DeleteReport",
  MaintainHierarchy = "MaintainHierarchy",
  MaintainHierarchyComments = "MaintainHierarchyComments",
  MaintainHierarchyUsers = "MaintainHierarchyUsers",
  ReadTlfItemsFromHierarchy = "ReadTlfItemsFromHierarchy",
  WriteToTlfItemsInHierarchy = "WriteToTlfItemsInHierarchy",
}

export enum eApplicationPermission {
  AllowJsonDownload = "AllowJsonDownload",
  AllowJsonUpload = "AllowJsonUpload",
  AllowHelpEdit = "AllowHelpEdit",
  AllowNewsEdit = "AllowNewsEdit",
  AllowStudyStandardDateEdit = "AllowStudyStandardDateEdit",
  UpdateStandardsSettings = "UpdateStandardsSettings",
}

export enum eHierarchy {
  TopLevel = "TopLevel",
  Directory = "Directory",
  StudyDirectory = "StudyDirectory",
  Report = "Report",
}

export enum eHierarchyLevel {
  TopLevel = "TopLevel",
  Corporate = "Corporate",
  TA = "TA",
  Project = "Project",
  Study = "Study",
  Report = "Report",
}

export enum eLinkType {
  CopiedFromTemplate = "CopiedFromTemplate",
  BasedOn = "BasedOn",
  HasVersion = "HasVersion",
  Successor = "Successor",
  Predecessor = "Predecessor",
}

export enum eReleaseStatus {
  Draft = "Draft",
  ReleasePending = "ReleasePending",
  Valid = "Valid",
  DecommissingPending = "DecomissionPending",
  Decommissioned = "Decommissioned",
  RetirePending = "RetirePending",
  Retired = "Retired",
}

export enum eTlfItemType {
  table = "Table",
  listing = "Listing",
  figure = "Figure",
  v1figure = "V1Figure",
  section = "Section",
}

export enum eHistoryType {
  Created = "Created",
  Updated = "Updated",
  Released = "Released",
  Decommissioned = "Decommissioned",
  Deleted = "Deleted",
  DeletionWithdrawn = "DeletionWithdrawn",
  Retired = "Retired",
}

export enum eTlfOutputType {
  Docx = "docx",
  Pdf = "pdf",
  Rtf = "rtf",
  Lst = "lst",
}

// TiFo entity view status
export enum eShowTiFo {
  ToC = "ToC view",
  Titles = "Titles",
  Footnotes = "Footnotes",
  Comments = "Comments",
  ProgramInfo = "Program info",
}

export enum SearchableEditorBlocks {
  Titles = "Titles",
  PageBy = "Page by",
  Footnotes = "Footnotes",
  TableHeaderData = "Table header",
  TableComments = "Table comments",
  TableBodyData = "Table body",
  TableBodyRowGroupComments = "Table body comments",
  StandardsNotes = "Standards notes",
  ProgrammerNotes = "Programmer notes",
}
